import { sirenActions } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import { bannerStyles } from '../styles/banner-styles';
import '../common/bn-icon';
import '../common/bn-modal';
import '../common/bn-modal-button';
import './entity-note-save';

const getOptions = type => ({
  'biosecurity': { style: 'critical', title: 'Biosecurity Note' },
  'service': { style: 'info', title: 'Service Note' },
}[type] || { style: 'info', title: 'Note' });

class EntityNote extends LitEntity {
  static get properties() {
    return {
      readonly: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, bannerStyles, css`
      .note {
        display: flex;
      }
      .content {
        flex-grow: 1;
      }
      .title {
        font-weight: bold;
      }
      .message {
        white-space: pre-wrap;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html``;
    }
    const note = this.entity;
    const { type, message } = note.properties;
    const { title, style } = getOptions(type);
    const clear = async () => {
      if (!window.confirm('Delete note?')) {
        return;
      }
      const action = note.getAction('delete-note');
      const { entity, response } = await sirenActions.submitAction(action);
      this.dispatchEvent(new CustomEvent('response', { detail: { entity, response }, bubbles: true, composed: true }));
    };
    return html`
      <div class="note banner banner--${style}">
        <div class="content">
          <span class="title">
            ${title}
          </span>
          <div class="message">${message}</div>
        </div>
        ${renderIf(!this.readonly, () => html`
          <div class="actions">
            ${renderIf(note.hasAction('update-note'), () => html`
              <bn-modal-button button-class="button banner--button--${style}" close-on-success>
                <span slot="text">Edit</span>
                <bn-modal slot="modal">
                  <span slot="title">Edit Note</span>
                  <div class="banner banner--info">
                    Notes are visible to all users who can view this organization.
                  </div>
                  <entity-note-save .href="${this.href}" actionname="update-note"></entity-note-save>
                </bn-modal>
              </bn-modal-button>
            `)}
            ${renderIf(note.hasAction('delete-note'), () => html`
              <button class="button button banner--button--${style}" @click="${clear}">
                <bn-icon name="far fa-times"></bn-icon>
              </button>
            `)}
          </div>
        `)}
      </div>
    `;
  }
}

customElements.define('entity-note', EntityNote);
